import { useLocation, Navigate } from "react-router-dom";
import { moduleForRoute, useModules } from "@/lib/modules";
import { useAuth } from "@/contexts/AuthContext";
import { Lock } from "lucide-react";

export function ModuleGuard({ children }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { enabled } = useModules();
  if (user?.role !== "owner") return children;
  const mod = moduleForRoute(pathname);
  if (!mod || enabled(mod)) return children;
  return (
    <div data-testid="module-off-page" className="max-w-xl mx-auto mt-10 rounded-2xl border border-fuchsia-900/40 bg-fuchsia-950/15 p-8 text-center space-y-3">
      <Lock className="h-10 w-10 text-fuchsia-300 mx-auto" />
      <h2 className="font-display text-xl font-black uppercase text-zinc-100">Módulo desligado</h2>
      <p className="text-sm text-zinc-400">Esta seção está desligada para a sua oficina. Nada foi apagado — fale com o suporte para ligar de novo.</p>
      <Navigate to="/owner" replace />
    </div>
  );
}
